export const drinkingWaterSystemReducerName = "drinkingWaterSystems";
